module.exports = __webpack_public_path__ + "270142667ad76d40ab5402a04f90c6b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/pricing/alipayicon.png
// module id = 445
// module chunks = 0